import style from './EmptyNotificationsList.css';
import NoNotifications from '../../../assets/images/no-notifications.webp';
import useTranslation from '../../../localization/i18n.context';

export default function EmptyNotificationsList({ className = '', ...props }) {
  const { t } = useTranslation();
  return (
    <div className={`${className} ${style['no-notifications']}`} {...props}>
      <img src={NoNotifications} width={80} height={80} />

      <div className={style.text}>
        <h3>
          {t("You don't have any notifications right now. Check back soon!")}
        </h3>
      </div>
    </div>
  );
}
